module.exports = __webpack_public_path__ + "img/jd.ab2f55ea.svg";